import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import { getBounds } from "../../common/utils/map.js";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZGFpc3kxMjMyMSIsImEiOiJjbGhhejhjNW8wbWduM2hvaThvOTgzamdpIn0.sLKvL0-cxWSUp_8awXxiJg";

export const createMap = (container, task) => {
  return new mapboxgl.Map({
    container: container,
    style: "mapbox://styles/mapbox/satellite-v9", // style URL
    interactive: true, // Needed for mapbox-gl-draw styling
    bounds: task.latitude ? getBounds(task) : null,
  });
};

export const showTask = (map, task) => {
  const bounds = getBounds(task);
  // Move the map to the central point
  map.fitBounds(bounds, { duration: 0 });
};

export const categories = [
  { color: "#419BDF", name: 1, label: "water" },
  { color: "#397D49", name: 2, label: "trees" },
  { color: "#88B053", name: 3, label: "grass" },
  { color: "#7A87C6", name: 4, label: "flooded_vegetation" },
  { color: "#E49635", name: 5, label: "crops" },
  { color: "#DFC35A", name: 6, label: "shrub and scrub" },
  { color: "#C4281B", name: 7, label: "built" },
  { color: "#A59B8F", name: 8, label: "bare" },
  { color: "#E87BC0", name: 9, label: "snow and ice" },
];

export const colorToName = Object.fromEntries(
  Object.entries(categories).map(([_, c]) => [c.color, c.name]),
);
export const colorToIndex = Object.fromEntries(
  Object.entries(categories).map(([i, c]) => [c.color, i]),
);
export const nameToColor = Object.fromEntries(
  Object.entries(categories).map(([_, c]) => [c.name, c.color]),
);

export function extractLabels(map, features) {
  return features.map((f) => {
    const fs = map.current.getFeatureState({
      source: "grid",
      id: f.id,
    });
    return { feature: f, label: colorToName[fs.color || null] };
  });
}
